import classNames from 'classnames';
import PropTypes from 'prop-types';

interface Props {
    name: string;
    className?: string;
}

const getSvgMarkup = (name: string) => require('../../../common/components/ui-svg-include/svgs/' + name + '.svg');

function UiSvg({ name, className }: Props) {
    'use memo';
    const props = {
        dangerouslySetInnerHTML: {
            __html: getSvgMarkup(name),
        },
        className: classNames('react-ui-svg', className),
    };
    return <span {...props} />;
}

(UiSvg as any).propTypes = {
    name: PropTypes.string.isRequired,
};

export default UiSvg;
